import React from 'react';
import FilterableDatatable from "../../components/table/filterable-data-table";
import ContractTradesTableHeader from "./contract-trades-table-header";
import ContractTradesTableRow from "./contract-trades-table-row";
import * as api from "../../api";
import ArrayDataProvider from "../../components/table/data-providers/array-data-provider";

class ContractTrades extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            dataProvider: new ArrayDataProvider([])
        };

        this.fetchData();
    }

    fetchData()
    {
        api.getContractTradeList(this.props.customerId, this.props.contractId)
            .then(({data}) => this.state.dataProvider.updateDataSource(data));
    }

    render() {
        return (
            <FilterableDatatable dataProvider={this.state.dataProvider} name="contract-trades" canExport={true}
                                 refreshDataTrigger={this.state.dataProvider.onDataSourceChanged}
                                 headerComponent={ContractTradesTableHeader} rowComponent={ContractTradesTableRow} />
        );
    }
}

export default ContractTrades;